export default "__VITE_ASSET__28a3b9e0__"